<template>
  <aside
    :class="{
      'is-floating': layout.sidebar === 'floating',
      'is-collapsed': layout.sidebar === 'collapsed',
      'is-expanded': layout.sidebar === 'expanded',
      'is-active': active
    }"
    class="border-right border-light"
    @mouseenter.self="mouseEnter"
    @mouseleave.self="mouseLeave"
  >
    <nav>
      <template v-for="(group, index) in items">
        <Items
          :key="index"
          :items="group"
        />
      </template>
    </nav>
  </aside>
</template>

<script>
import Items from '@/components/Navigation/Sidebar/Items'
import { mapState } from 'vuex'

export default {
  components: {
    Items
  },
  data () {
    return {
      active: false
    }
  },
  computed: {
    ...mapState('configuration', [ 'layout' ]),
    items () {
      let items = this.$navigation.sidebar

      if (items.length && items[0].constructor !== Array) {
        items = [ items ]
      }

      return items
    }
  },
  watch: {
    '$route' () {
      this.mouseLeave()
    }
  },
  methods: {
    mouseEnter () {
      this.active = true
    },
    mouseLeave () {
      this.active = false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "variables";

  aside:first-of-type {
      top: calc(#{$topbar-height} + #{$header-height});
      left: 0;
      width: calc(#{$sidebar-width} - #{$sidebar-border-right-width});
      max-width: calc(100vw - #{$sidebar-border-right-width});
      height: calc(100vh - (#{$topbar-height} + #{$header-height}));
      background-color: $sidebar-background-color;
      color: rgba(0, 0, 0, 0.45);
      transition: $sidebar-transition;
      overflow: hidden;
      white-space: nowrap !important;
      float: left;

      &.is-active,
      &.is-expanded {
        width: $sidebar-expanded-width;
        color: $sidebar-color;
      }

      &.is-floating {
        position: fixed;
        z-index: $zindex-fixed;
      }

      &.is-collapsed {
        width: $sidebar-width;
      }

      nav {
        width: 200vw;
        height: calc(100vh - (#{$sidebar-item-height} * 2) - #{$topbar-height});
        overflow-x: hidden;
        overflow-y: scroll;
      }
  }
</style>
